import React, { Fragment, useMemo, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import EventNoteIcon from "@mui/icons-material/EventNote";
import InfoIcon from "@mui/icons-material/Info";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonIcon from "@mui/icons-material/Person";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Pagination,
  Skeleton,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from "@mui/material";

import { formatDistanceToNow } from "date-fns";
import { useAuth } from "oidc-react";
import { useNavigate } from "react-router-dom";

import { Icon } from "@progress/kendo-react-common";

import { useEffect } from "react";

import { Close } from "@material-ui/icons";
import {
  AssignmentLate,
  Circle,
  Event,
  Info,
  PriorityHigh,
  Reply
} from "@mui/icons-material";
import axios from "axios";
import moment from "moment-timezone";
import { put } from "../../_helper/api_helper";
import { getUserId, getUserRole, ShowError, ShowSucess } from "../../_helper/helper";
import { advanceSearch } from "../../_helper/services/advanceSearchv2";
import { loadingPanel } from "../../CommonComponents/CommonFunction";
import ErrorBoundary from "../../ErrorBoundry";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { debounce, set } from "lodash";




const Search = styled("div")(({ theme }) => ({
  position: "relative",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: theme.shape.borderRadius,
  "&:hover": {
    // backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "rgba(0, 0, 0, 1)",
}));


const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const BenefitsDashboardMain = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();

  const [data, setData] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [rowCount, setRowCount] = useState(null);
  const [priority, setPriority] = useState("all");
  const [transactionType, setTransactionType] = useState("Benefits");
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState('all');

  const [isReplyModel, setIsReplyModel] = useState(false);
  const [replayData, setReplayData] = useState({});
  const [replyText, setReplyText] = useState("");
  // const { connection } = useContext(SocketAppContext);
  const getNoticeData = async (searchtext = null, pageNumber = null, priority = null) => {
    console.log("Dasadadadsadads", searchtext);

    setLoading(true);
    let additionalWhere = "";

    if (priority === "all") {
      additionalWhere += `priority <> 'Past Due'`;
    }

    if (priority !== "all" && priority) {
      additionalWhere += `priority = '${priority}'`;
    }

    if (searchtext) {
      additionalWhere = ``
    }

   

    //   if (transactionType?.trim()) {
    //     additionalWhere += additionalWhere
    //       ? ` AND (Dept_No  in (select TRIM(value) from string_split('02,06',','))
    //  AND EmployeeID != '${getUserId(userData)}' and TransactionType = 'Benefits' ${searchtext ? `AND Action_Description like '%${searchtext}%'` : ''}) or ((EmployeeID ='0' OR EmployeeID = '-1' )  AND TransactionType = 'Benefits' ${searchtext ? `AND Action_Description like '%${searchtext}%'` : ''})   `
    //       : ` (Dept_No  in (select TRIM(value) from string_split('02,06',','))
    //  AND EmployeeID != '${getUserId( userData )}' and TransactionType = 'Benefits'  ${searchtext ? `AND Action_Description like '%${searchtext}%'` : ''}) or ((EmployeeID ='0' or EmployeeID = '-1')  AND TransactionType = 'Benefits' ${searchtext ? `AND Action_Description like '%${searchtext}%'` : ''}) `;
    //   }
    // if (transactionType?.trim()) {
    //   additionalWhere += additionalWhere
    //     ? ` AND TransactionType = '${transactionType}' AND (EmployeeID = '${getUserId(userData)}' or EmployeeID = 0 or EmployeeID is null)`
    //     : `TransactionType = '${transactionType}' AND (EmployeeID = '${getUserId(userData)}' or EmployeeID = 0 or EmployeeID is null)`;
    // }
    console.log("Dasddadadadasda 1 ", additionalWhere);


    console.log("Dasddadadadasda 2 ", additionalWhere);
    let sortingDta = '';
    if (priority === 'Past Due') {
      sortingDta = "[CreatedDate] asc"
    } else {
      sortingDta = "[CreatedDate] desc"
    }

    const payload = {
      tableName: "sp_benefite_dept_dashboard",
      SearchParams: `[{"columnName":"userrole","operator":"=","value":'${getUserRole(userData)}',"dataType":"VARCHAR"}, {"columnName":"Action","operator":"=","value":'${filter}',"dataType":"VARCHAR"}]`,
      columns: "*",
      pageNumber: pageNumber ? pageNumber : currPage,
      pageSize: pageSize,
      sortData: sortingDta,
      additionalWhere: additionalWhere,
      location: "Benefits-global"
    };

    try {
      const response = await advanceSearch(payload, "Benefits");
      const { results, rowCount } = response;
      setData(results);
      setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
      setCurrPage(currPage)
    } finally {
      setLoading(false);
    }
  };


  console.log(userData, 'userData')

  useEffect(() => {
    if (filter !== 'all') {
      getNoticeData(search, 1, priority);
    } else {
      getNoticeData();
    }
  }, [filter]);

  // useEffect(() => {
  //   if (filter !== 'all') {
  //     getNoticeData(search, 1, priority);
  //   }
  // }, [filter]);

  const handelDebounce = (searchtext) => {
    console.log("sadadadadadsadad", searchtext?.length);
    setTimeout(() => {
      if (searchtext?.length >= 3) {
        getNoticeData(searchtext)
      }
    }, 800);

  }

  // useEffect(() => {
  //   setData(defaultData);
  //   setRowCount(20);
  //   setLoading(false);
  //   setPageSize(5);
  // }, [defaultData]);
  const getBackgroundColor = (priority) => {
    switch (priority) {
      case "Urgent":
        return "red";
      case "Non-Urgent":
        return "whitesmoke";
      case "Acknowledgement":
        return "lightyellow";
      case "FYI":
        return "lightyellow";
      case "Notification":
        return "yellow";
      case "Past Due":
        return "orange";
      default:
        return "white";
    }
  };

  const pallets = {
    All: {
      bg: "#eceff1",
      text: "#607d8b",
    },
    "Action Required": {
      bg: "#ffebee",
      text: "#f44336",
      icon: <PriorityHigh />,
    },
    "Non-Urgent": {
      bg: "#e3f2fd",
      text: "#2196f3",
      icon: <Event />,
    },
    FYI: {
      bg: "#e0f7fa",
      text: "#00bcd4",
      icon: <Info />,
    },
    Acknowledgement: {
      bg: "#e0f7fa",
      text: "#00bcd4",
      icon: <Info />,
    },
    Notification: {
      bg: "#e8f5e9",
      text: "#4caf50",
      icon: <NotificationsIcon />,
    },
    "Past Due": {
      bg: "#fff3e0",
      text: "#ff9800",
      icon: <AssignmentLate />,
    },
  };

  const getColor = (pt) => {
    return pallets[pt] || null;
  };

  const getTextColor = (priority) => {
    return priority === "Action Required" ? "red" : "black";
  };

  const getIcon = (transactionType) => {
    switch (transactionType) {
      case "Notification":
        return <NotificationsIcon />;
      case "Information":
        return <InfoIcon />;
      case "Personal Action":
        return <PersonIcon />;
      case "Leave Application":
        return <BeachAccessIcon />;
      default:
        return <EventNoteIcon />;
    }
  };

  const handlePageChange = (event, value) => {
    getNoticeData(search, value)
    setCurrPage(value);
  };

  const handlePriorityChange = (event, newPriority) => {
    if (newPriority) {
      setPriority(newPriority);
      getNoticeData(search, 1, newPriority)
      setCurrPage(1); // Reset to the first page whenever the priority changes
    }
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
    setCurrPage(1); // Reset to the first page whenever the transaction type changes
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };


  const handleApproveJob = async () => {
    if (!replyText?.trim()) {
      ShowError("Reply text is required!");
      return false;
    }
    setIsLoading(true);
    const payload = {
      "employeeId": 0,//replayData?.EmployeeID,
      "notificationText": replyText,
      "application": replayData?.Application,//"Benefits",
      "parentId": replayData?.ID,
      remark: replayData?.Action_Description
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_DOTNET_URL}/Notification/NotificationReply`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
            // Role: getUserRole(userData),
          },
        }
      );
      ShowSucess("Successfully Replied!"); // Correct spelling of ShowSuccess
    } catch (error) {
      console.error(error); // Log the error for debugging
      ShowError("Internal Server Error!");
    } finally {
      setIsLoading(false);
      setIsReplyModel(false);
    }
  };

  const handleRead = (item) => {
    setReplayData(item);
    setReplyText("");
    setIsReplyModel(true);
  };
  function removeHtmlTags(str) {
    if (str === null || str === "") {
      return false;
    } else {
      str = str.toString();
    }
    return str.replace(/<[^>]*>/g, "");
  }

  const markAsRead = (payload) => {
    put(
      `${process.env.REACT_APP_API_DOTNET_URL}/Notification/NotificationMarkAsRead`,
      payload
    );
    // Opration
  };

  useEffect(() => {
    if (data?.length) {
      let filterData = data
        .filter((i) => i.IsRead == false)
        .map((i) => {
          return parseInt(i.ID);
        });
      const payload = { id: filterData };

      if (filterData?.length) {
        setTimeout(() => {
          markAsRead(payload);
        }, 10000);
      }
    }
  }, [data]);


  // useEffect(() => {
  //   if (connection) {

  //     connection.on("ReceiveNotification", (response) => {
  //       console.log("Notification received in another component:", response);
  //     });

  //     // Clean up the event listener on component unmount
  //     // return () => {
  //     //   connection.off("ReceiveNotification");
  //     // };
  //   }
  // }, [connection]);

  const handleChange = (event, newPriority) => {
    // if (newPriority === 'Health') {
    //   setPriority("Action Required")
    // }
    if (newPriority !== null) {
      setFilter(newPriority);
    }

  };


  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
        {isLoading && loadingPanel()}

        <Container fluid={true}>
          {/* <NotificationPage
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              notificationId={notificationId}
              hideButton={true}
            /> */}
          <Row className="bg-primary rounded py-3 mb-3">
            <Typography variant="h5">
              <Icon
                style={{ fontSize: "25px", margin: "10px" }}
                name="file-data"
              />
              Dashboard
            </Typography>
          </Row>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody className="p-3">
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <ToggleButtonGroup
                      value={priority}
                      exclusive
                      onChange={handlePriorityChange}
                      aria-label="priority"
                      size="small"
                    >
                      <ToggleButton
                        value="all"
                        aria-label="all"
                        sx={{
                          // backgroundColor: "grey",
                          "&.Mui-selected": {
                            backgroundColor: getColor("All")?.bg,
                            color: getColor("All")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            color: getColor("All")?.text,
                          }}
                        >
                          {/* <Circle
                              sx={{ fontSize: "15px", marginRight: 1 }}
                            ></Circle> */}
                          All
                          {/* {priority === "all" && (
                              <CheckIcon
                                sx={{ marginLeft: 1, fontSize: "15px" }}
                              />
                            )} */}
                        </Box>
                      </ToggleButton>
                      {/* <ToggleButton
                        value="Urgent"
                        aria-label="urgent"
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: getColor("Urgent")?.bg,
                            color: getColor("Urgent")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            color: getColor("Urgent")?.text,
                          }}
                        >
                          <Circle
                            sx={{
                              fontSize: "15px",
                              margin: "5px",
                              color: "red",
                            }}
                          ></Circle>
                          Urgent
                          
                        </Box>
                      </ToggleButton> */}
                      {/* <ToggleButton
                        value="Non-Urgent"
                        aria-label="non-urgent"
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: getColor("Non-Urgent")?.bg,
                            color: getColor("Non-Urgent")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            color: getColor("Non-Urgent")?.text,
                          }}
                        >
                          <Circle
                            sx={{
                              fontSize: "15px",
                              margin: "5px",
                            }}
                          ></Circle>
                          Non-Urgent
                        
                        </Box>
                      </ToggleButton> */}
                      <ToggleButton
                        value="Action Required"
                        aria-label="urgent"
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: getColor("Action Required")?.bg,
                            color: getColor("Action Required")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: '5px',
                            width: "auto",
                            color: getColor("Action Required")?.text,
                          }}
                        >
                          {/* <Circle
                            style={{ fontSize: "15px" }}
                            sx={{
                              fontSize: "15px",
                              margin: "5px",
                              color: "red",
                            }}
                          ></Circle> */}
                          <Avatar sx={{ bgcolor: getColor("Action Required").bg, width: 20, height: 20, border: `1px ${getColor("Action Required").text} solid` }}>
                            <PriorityHigh
                              sx={{
                                fontSize: "15px",
                                margin: "5px",
                                color: getColor("Action Required").text
                              }}
                            />
                          </Avatar>
                          Action Required

                        </Box>
                      </ToggleButton>
                      {/* <ToggleButton
                        value="Acknowledgement"
                        aria-label="fyi"
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: getColor("Acknowledgement")?.bg,
                            color: getColor("Acknowledgement")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "auto",
                            color: getColor("Acknowledgement")?.text,
                          }}
                        >
                          <Circle
                            sx={{
                              fontSize: "15px",
                              margin: "5px",
                            }}
                          ></Circle>
                          Acknowledgement
                        </Box>
                      </ToggleButton> */}
                      <ToggleButton
                        value="Notification"
                        aria-label="notification"
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: getColor("Notification")?.bg,
                            color: getColor("Notification")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            width: "100px",
                            color: getColor("Notification")?.text,
                          }}
                        >
                          {/* <Circle
                            sx={{
                              fontSize: "15px",
                              margin: "5px",
                            }}
                          ></Circle> */}

                          <Avatar sx={{ bgcolor: getColor("Notification").bg, width: 20, height: 20, border: `1px ${getColor("Notification").text} solid` }}>
                            <NotificationsIcon
                              sx={{
                                fontSize: "15px",
                                margin: "5px",
                                color: getColor("Notification").text
                              }}
                            />
                          </Avatar>
                          Notification

                        </Box>
                      </ToggleButton>
                      <ToggleButton
                        value="Past Due"
                        aria-label="past due"
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor: getColor("Past Due")?.bg,
                            color: getColor("Past Due")?.text,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            width: "100px",
                            color: getColor("Past Due")?.text,
                          }}
                        >
                          {/* <Circle
                            sx={{
                              fontSize: "15px",
                              margin: "5px",
                            }}
                          ></Circle> */}
                          <Avatar sx={{ bgcolor: getColor("Past Due").bg, width: 20, height: 20, border: `1px ${getColor("Past Due").text} solid` }}>
                            <AssignmentLate
                              sx={{
                                fontSize: "15px",
                                margin: "5px",
                                color: getColor("Past Due").text
                              }}
                            />
                          </Avatar>
                          Past Due
                        </Box>
                      </ToggleButton>
                    </ToggleButtonGroup>
                    <Search>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          handelDebounce(e.target.value);
                        }}
                        inputProps={{ "aria-label": "search" }}
                      />
                    </Search>
                    {/* <Box sx={{ display: "flex", alignItems: "center" }}> */}
                    {/* <FormControl
                          size="small"
                          sx={{ minWidth: 200, marginRight: 2 }}
                        >
                          <InputLabel shrink={true}> Transaction Type</InputLabel>
                          <Select
                            value={transactionType}
                            onChange={handleTransactionTypeChange}
                            label="Transaction Type"
                            notched={true}
                          >
                            <MenuItem value=" ">
                              <em>--select--</em>
                            </MenuItem>
                            <MenuItem value="Notification">Notification</MenuItem>
                            <MenuItem value="Personal Action">
                              Personal Action
                            </MenuItem>
                            <MenuItem value="Leave Application">
                              Leave Application
                            </MenuItem>
                          </Select>
                        </FormControl> */}
                    {/* <Pagination
                        count={Math.ceil(rowCount / pageSize)}
                        page={currPage}
                        onChange={handlePageChange}
                        color="primary"
                      /> */}
                    {/* </Box> */}
                  </Box>
                  {(priority === "Action Required" && userData?.profile?.role === "BenefitsGovernmentWideManagement" || priority === "Past Due" && userData?.profile?.role === "BenefitsGovernmentWideManagement") && <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0px 0px 20px 40px"
                      // mb: 2,
                    }}
                  >
                    <ToggleButtonGroup
                      value={filter}
                      exclusive
                      onChange={handleChange}
                      aria-label="filter"
                      size="small"
                    >
                      <ToggleButton
                        value="all"
                        aria-label="all"
                        sx={{
                          // backgroundColor: "grey",
                          "&.Mui-selected": {
                            color: "blue",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            // color: "black",
                          }}
                        >

                          All

                        </Box>
                      </ToggleButton>
                      <ToggleButton
                        value="Health"
                        aria-label="healthPlan"
                        sx={{
                          // backgroundColor: "grey",
                          "&.Mui-selected": {
                            color: "blue",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            // color: "black",
                          }}
                        >
                          Health Plan
                        </Box>
                      </ToggleButton>
                      <ToggleButton
                        value="Dental"
                        aria-label="fyi"
                        sx={{
                          // backgroundColor: "grey",
                          "&.Mui-selected": {
                            color: "blue",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            // color: "black",
                          }}
                        >
                          Dental Plan
                        </Box>
                      </ToggleButton>
                      <ToggleButton
                        value="Life"
                        aria-label="notification"
                        sx={{
                          // backgroundColor: "grey",
                          "&.Mui-selected": {
                            color: "blue",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            // color: "black",
                          }}
                        >
                          Life Insurance
                        </Box>
                      </ToggleButton>
                      {priority === "Past Due" && <ToggleButton
                        value="Employee"
                        aria-label="employee"
                        sx={{
                          // backgroundColor: "grey",
                          "&.Mui-selected": {
                            color: "blue",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100px",
                            // color: "black",
                          }}
                        >
                          Employee
                        </Box>
                      </ToggleButton>}
                    </ToggleButtonGroup>

                  </Box>}
                  {loading ? (
                    <List sx={{ padding: 2 }}>
                      {[...Array(5)].map((_, index) => (
                        <ListItem key={index} sx={{ marginBottom: "10px" }}>
                          <ListItemAvatar>
                            <Skeleton
                              variant="circular"
                              width={40}
                              height={40}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={<Skeleton variant="text" />}
                            secondary={<Skeleton variant="text" width="60%" />}
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : data.length === 0 ? (
                    <Typography variant="h6" align="center">
                      No Transactions
                    </Typography>
                  ) : (
                    <List sx={{ padding: 2 }}>
                      {data.map((item, index) => (
                        <ListItem
                          key={index}
                          style={{
                            //   backgroundColor: getColor(item.Priority)?.bg,
                            color: getTextColor(item.Priority),
                            borderBottom: "1px solid gray",
                            marginBottom: "10px",
                            position: "relative",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              style={{
                                background: getColor(item.Priority)?.bg,
                                border: `1px solid ${getColor(item.Priority)?.text
                                  }`,
                                color: getColor(item.Priority)?.text,
                              }}
                            >
                              {getColor(item.Priority)?.icon}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (item.TransactionType == "Dental") {
                                navigate(
                                  `/dental-enrollment/${item.EmployeeID}/update`
                                );
                              } else if (item.TransactionType == "Health") {
                                navigate(
                                  `/health-enrollment/${item.EmployeeID}/update`
                                );
                              } else if (item?.TransactionType == "Life") {
                                navigate(
                                  `/coverage-Change/${item.EmployeeID}`
                                );
                              }
                            }}
                            primary={
                              <>
                                <Typography
                                  variant="body1"
                                  sx={{ color: getTextColor(item.Priority), width: '80% !important' }}
                                >
                                  {item.Action_Description}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: getTextColor(item.Priority) }}
                                >
                                  {`Create Date: ${formatDate(item.CreatedDate)}
                                    `}
                                </Typography>
                              </>
                            }
                          // secondary={
                          //   <>
                          //     <Typography
                          //       variant="body2"
                          //       sx={{ color: getTextColor(item.Priority) }}
                          //     >{`ID: ${item.HrControl}`}</Typography>
                          //   </>
                          // }
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              textAlign: "right",
                            }}
                          >
                            <Typography
                              cla
                              variant="body2"
                              sx={{ color: getTextColor(item.Priority) }}
                            >{`TransactionType: ${item.TransactionType}`}</Typography>
                            {/* <Typography
                              variant="body2"
                              sx={{ color: getTextColor(item.Priority) }}
                            >{`Status: ${item.Status}`}</Typography> */}
                          </Box>
                          <Box
                            sx={{
                              position: "absolute",
                              bottom: 5,
                              right: 8,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {/* {item.EmployeeID !== userData?.profile?.EmployeeID && <Reply
                              className="mx-1"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleRead(item);
                              }}
                              sx={{
                                color: getTextColor(item.Priority),
                              }}
                            />} */}

                            <EventNoteIcon
                              sx={{
                                marginRight: 1,
                                color: getTextColor(item.Priority),
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ color: getTextColor(item.Priority) }}
                            >
                              {/* {formatDistanceToNow(
                                new Date(item.CreatedDate),
                                { addSuffix: true, locale: true }
                              )} */}
                              {formatDistanceToNow(
                                new Date(
                                  moment.tz(item.CreatedDate, "UTC").local()
                                ),
                                {
                                  addSuffix: true,
                                }
                              )}
                              {/* {moment(item.CreatedDate).startOf('day').fromNow()} */}
                              {/* {moment.utc(item.CreatedDate).startOf('day').fromNow()} */}
                            </Typography>
                          </Box>
                        </ListItem>
                      ))}
                    </List>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      mt: 2,
                    }}
                  >
                    <Pagination
                      count={Math.ceil(rowCount / pageSize)}
                      page={currPage}
                      onChange={handlePageChange}
                      color="primary"
                    />
                  </Box>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Dialog
          onClose={() => {
            setIsReplyModel(false);
          }}
          aria-labelledby="customized-dialog-title"
          open={isReplyModel}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Notification Reply
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => {
              setIsReplyModel(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom className="mb-2">
              {replayData?.Action_Description
                ? removeHtmlTags(replayData?.Action_Description)
                : null}
            </Typography>

            <Typography gutterBottom>
              {/* <FormControl id={"status"}>
                  <RadioGroup
                    aria-label="status"
                    value={jobStatus}
                    style={{ display: "block" }}
                    onChange={(e) => {
                      setJobStatus(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      className="px-24 py-8"
                      value={"Accept"}
                      control={<Radio />}
                      label={"Available"}
                    />
                    <FormControlLabel
                      className="px-24 py-8"
                      value={"Decline"}
                      control={<Radio />}
                      label={"Not Interested"}
                    />
                  </RadioGroup>
                </FormControl> */}
              <div>
                <TextField
                  multiline
                  fullWidth
                  value={replyText}
                  onChange={(e) => {
                    setReplyText(e.target.value);
                  }}
                  rows={3}
                  error={!replyText?.trim()}
                  required
                  label="Reply Text"
                />
                {/* <Errorlable text={errors.description} /> */}
              </div>
              {/* 
                <div style={{ marginTop: "1rem", color: "red" }}>
                  {getRemaingDay(currentView?.CreatedDate)?.days > 0
                    ? `${
                        getRemaingDay(currentView?.CreatedDate)?.days
                      } Days remains to take action. if no action taken, considered as decline`
                    : getRemaingDay(currentView?.CreatedDate)?.days == 0
                    ? "Today is the last day to take action. if no action taken, considered as decline"
                    : "Notification Expired"}
                </div> */}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              variant="contained"
              onClick={() => {
                handleApproveJob();
                // setOpen(false)
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    </ErrorBoundary>
  );
};
export default BenefitsDashboardMain;
